import {Box, LinearProgress} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StickyContainerWrapper = styled(Box)(({theme}) => ({
  position: 'sticky',
  bottom: theme.spacing(1),
  left: theme.spacing(2),
  right: theme.spacing(2),
  width: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 2
}));

export const WeightCapacityContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'fullWidth'
})<{fullWidth?: boolean}>(({theme, fullWidth}) => ({
  width: fullWidth ? '100%' : 'calc(100% - 16px)',
  backgroundColor: '#FFEBE5',
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1, 1.5),
  boxSizing: 'border-box',
  margin: '0 auto'
}));

export const WeightCapacityTop = styled(Box)(() => ({
  width: '100%',
  height: 'auto',
  display: 'flex',
  justifyContent: 'space-between'
}));

export const WeightCapacityBottom = styled(Box)(({theme}) => ({
  width: '100%',
  height: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}));

export const StyledProgressBox = styled(Box)(({theme}) => ({
  position: 'relative',
  width: '100%',
  flex: 1,
  padding: theme.spacing(0.75, 0)
}));

export const StyledProgressBar = styled(LinearProgress)(({theme}) => ({
  backgroundColor: '#F4F4F4',
  height: theme.spacing(0.5),
  borderRadius: theme.spacing(6),
  ' .MuiLinearProgress-bar': {
    backgroundColor: '#E82026'
  }
}));
